import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function QuickAbout() {
  const { t } = useTranslation();

  const data = [
    {
      title: t("quickAbout.profileMetalike"),
      description: t("quickAbout.profileMetalikeDesc"),
    },
    {
      title: t("quickAbout.slitingLine"),
      description: t("quickAbout.slitingLineDesc"),
    },
    {
      title: t("quickAbout.cutToLength"),
      description: t("quickAbout.cutToLengthDesc"),
    },
    {
      title: t("quickAbout.pvc"),
      description: t("quickAbout.pvcDesc"),
    },
  ];
  const [imgRef, imgVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation();
  const [item1Ref, item1Visible] = useScrollAnimation();
  const [item2Ref, item2Visible] = useScrollAnimation();
  const [item3Ref, item3Visible] = useScrollAnimation();
  const [item4Ref, item4Visible] = useScrollAnimation();

  const itemRefs = [item1Ref, item2Ref, item3Ref, item4Ref];
  const itemVisibles = [item1Visible, item2Visible, item3Visible, item4Visible];

  return (
    <div className="quickabout-wrapper">
      <div className="quickabout container flex">
        <img
          ref={imgRef}
          src="/assets/images/logoGreen.png"
          className={`quickabout-img ${imgVisible ? "animate-in" : ""}`}
          alt="Quick About"
        />
        <div
          ref={contentRef}
          className={`quickabout-content flex ${
            contentVisible ? "animate-in" : ""
          }`}
        >
          {data.map((item, index) => (
            <div
              key={index}
              ref={itemRefs[index]}
              className={`quickabout-item flex ${
                itemVisibles[index] ? "animate-in" : ""
              }`}
            >
              <img src="/assets/icons/arrowRightWhite.svg" alt="" />
              <div>
                <h3 className="fs-700 clr-white medium">{item.title}</h3>
                <p className="fs-500 clr-white">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default QuickAbout;
